<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="8" y1="1" x2="8" y2="15" stroke="#C41E3A" stroke-width="2.2" stroke-linecap="round"/>
    <line x1="1.07" y1="4.5" x2="14.93" y2="11.5" stroke="#C41E3A" stroke-width="2.2" stroke-linecap="round"/>
    <line x1="14.93" y1="4.5" x2="1.07" y2="11.5" stroke="#C41E3A" stroke-width="2.2" stroke-linecap="round"/>
  </svg>
</template>
